import React, { useEffect } from 'react'; 
import Navbar from '../Navbar';
import ContactUsBody from './ContactUsBody';
import Footer from '../Footer';
import { appInsights } from '../../api/AppInsights';
const ContactUs = () => {
   useEffect(() => {
      appInsights.trackPageView({ name: 'Contact Us Page' });
    }, []);
    
  return (
    <>
      <Navbar />
      <ContactUsBody />
      <Footer />
    </>
  );
};

export default ContactUs;